const animateSlider = () => {
  const targetElement = document.querySelector(".swipe-tile");
  let animationShownOnPageLoad = false;
  const element = document.querySelector(".swipe-tile .swiper-wrapper");
  const transformStyle = element.style.transform;
  const match = transformStyle.match(/translate3d\(([^,]+),/);
  if (match) {
    let translateXValue = match[1];
    translateXValue = Number(translateXValue.replace("px", ""));
    const viewport = Math.floor(window.innerWidth / Math.abs(translateXValue));

    element.style.setProperty("--translateXStartValue", `${translateXValue}px`);
    element.style.setProperty(
      "--translateXEndValue",
      `${1.7 * translateXValue + 20 / viewport}px`
    );
    element.classList.add("swiper-animation-left-right-left");
  }
  animationShownOnPageLoad = true;
  const indicators = document
    .querySelectorAll(".ProductItem__Wrapper")[0]
    .querySelectorAll(".swiper-pagination-bullet");
  indicators.forEach((indicator) => {
    indicator.classList.add("ind-hidden");
  });
  setTimeout(() => {
    document
      .querySelectorAll(".swiper-pagination-bullet")
      .forEach((indicator) => {
        indicator.classList.remove("ind-hidden");
      });
  }, 1500);
  sessionStorage.setItem("animationSeen", "true");
};

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".swipe-tile")) {
      this.classList.add("swiped");
      setTimeout(() => {
        this.classList.add("bounce");
        setTimeout(() => {
          this.classList.remove("swiped", "bounce");
        }, 1000);
      }, 500);
    }
  });
});

setTimeout(() => {
  if (
    !sessionStorage.getItem("animationSeen") ||
    sessionStorage.getItem("animationSeen") !== "true"
    && document.querySelector(".ProductItem__Wrapper")
  ) {
    document.querySelector(".swipe-tile .swiper-wrapper") && animateSlider();
  }
}, 1000);
